import * as city from 'src/api/city'
import router from 'src/router'
import {
  GET_ALL_CITY,
  GET_CITY,
  GET_BLOCK_CITY
} from 'src/store/mutation-types'

const getAllCity = ({commit, dispatch}, params) => {
  dispatch('toggleLoadding', true, {root: true})
  city.getAllCity(params).then(response => {
    if (response.code === 200) {
      dispatch('toggleLoadding', false, {root: true})
      commit(GET_ALL_CITY, response.data)
    } else {
      dispatch('toggleLoadding', false, {root: true})
      commit(GET_ALL_CITY, [])
    }
  })
}

const getCity = ({commit, dispatch}, configs) => {
  dispatch('toggleLoadding', true, {root: true})
  city.getCity(configs).then(response => {
    switch (response.code) {
      case 200:
        dispatch('toggleLoadding', false, {root: true})
        commit(GET_CITY, response.data)
        break
      case 404:
        dispatch('toggleLoadding', false, {root: true})
        dispatch('showNotify', {
          title: 'Không tìm thấy tài nguyên',
          body: 'Tỉnh thành không tồn tại trên hệ thống',
          type: 'warning'
        }, {root: true})
        router.push({name: 'city'})
        break
      default:
        dispatch('toggleLoadding', false, {root: true})
    }
  })
}

const setCity = ({commit}, city) => {
  commit(GET_CITY, city)
}

const getBlockCities = ({commit, dispatch}, params) => {
  dispatch('toggleLoadding', true, {root: true})
  city.getAllCity(params).then(response => {
    switch (response.code) {
      case 200:
        dispatch('toggleLoadding', false, {root: true})
        commit(GET_BLOCK_CITY, response.data)
        break
      case 404:
        dispatch('toggleLoadding', false, {root: true})
        dispatch('showNotify', {
          title: 'Không tìm thấy tài nguyên',
          body: 'Tỉnh thành không tồn tại trên hệ thống',
          type: 'warning'
        }, {root: true})
        router.push({name: 'city'})
        break
      default:
        dispatch('toggleLoadding', false, {root: true})
    }
  })
}

export default{
  getAllCity,
  getCity,
  getBlockCities,
  setCity
}



// WEBPACK FOOTER //
// ./src/components/city/store/actions.js